import { h } from 'preact';
import { useMemo, useState } from 'preact/hooks';
import Image from 'utils/image';
import { formatMoney } from 'utils/storefront/format-resource';
import IconPlus from 'utils/icon/icon-plus.svg';
import IconMinus from 'utils/icon/icon-minus.svg';
import { withCartContext } from './cart-context';
import extractAndFormat from '../utils/extract-and-format';
import { getRechargeDataFromStorage } from '../product/product-form'
import './cart-recharge.css';
import { useEffect } from 'preact/hooks';
import { getVisibleElements } from './../utils/focus';

export const removeCartSkeleton = () => {
  document.querySelector('.cart-skeleton')?.classList.add('hidden');
  document.querySelector('.cart-page')?.classList.remove('invisible', 'h-0');
}
const CartItem = (props) => {
  const { cart, line, freeSamplesTag, sellingPlanTextChoosen, sellingPlanText, showLoading, index } = props;
  const freeSample = (line.product_type === freeSamplesTag) && line.product_type != '';
  let maxQuantity = line.variantMetafields?.cartValidation?.quantityLimit ||
    line.productMetafields?.cartValidation?.quantityLimit ||
    Infinity;
  const [errorMessage, setErrorMessage] = useState(false);
  const [block, setBlock] = useState(false);
  if (line.children) {
    // If bundle, get lowest child quantity
    maxQuantity = line.children.reduce((prevQuantity, child) => {
      const childMax =
        (cart.mode === 'storefront'
          ? child.merchandise?.quantityAvailable
          : child.quantity_rule?.maxQuantity) || Infinity;
      return childMax < prevQuantity ? childMax : prevQuantity;
    }, Infinity);
  }

  const handleAdjustQuantity = async (quantity) => {
    const lineError = line.variantMetafields?.cartValidation?.errorMessage ||
      line.productMetafields?.cartValidation?.errorMessage ||
      `Can't add more than ${maxQuantity}`
    const qty = quantity > maxQuantity ? maxQuantity : quantity;
    let payload = [
      {
        id: line.key,
        quantity: qty,
        selling_plan: line.selling_plan_allocation && line.selling_plan_allocation.selling_plan ? line.selling_plan_allocation.selling_plan.id : null
      },
    ];
    // If bundle, add children to update request
    if (line.children) {
      payload = line.children.map((child) => ({
        id: child.id,
        attributes: child.attributes,
        quantity: qty,
      }));
    }
    const allPromises = payload.map(async (item) => {
      return cart.change(item)
    })
    Promise.all(allPromises)
      .then(() => cart.get())
      .then((res) => {
        const matchedProduct = res?.items?.find((item) => item.id === line.id);
        const matchedProductQuantity = matchedProduct ? matchedProduct.quantity : 0;
        setErrorMessage(matchedProductQuantity == maxQuantity ? lineError : false)
      })
  };

  const handleRemove = async () => {
    // check which item delete by key not by id
    let payload = [line.key];

    // If bundle, add children to update request
    if (line.children) {
      payload = line.children.map((child) => child.id);
    }

    await cart.remove(payload);
    await cart.get();
  };

  const changeCartItemBySellingPlan = (selling_plan) => {
    setBlock(true)
    const merchandiseId = `id://shopify/ProductVariant/${line.id}`;
    const quantity = line.quantity;
    changeSubscriptionofItem(line.key, merchandiseId, quantity, selling_plan)
  }

  const changeSubscriptionofItem = async (key, merchandiseId, quantity, selling_plan) => {
    showLoading(true);
    document.querySelector('.loading-spinner')?.focus();
    await cart.change({
      id: merchandiseId,
      selling_plan: selling_plan || null,
      quantity
    },);
    await cart.get()
    showLoading(false);
    const focusableElements = getVisibleElements(container.querySelectorAll('button, input, select, textarea, [tabindex]:not([tabindex="-1"])'))
    focusableElements[0].focus();
  }

  const handleUpdateRechargeItem = (e) => changeCartItemBySellingPlan(e.target.value);

  const changeSellingPlan = () => {
    setBlock(true)
    if (line.selling_plan_allocation) {
      const merchandiseId = `id://shopify/ProductVariant/${line.id}`;
      const quantity = line.quantity;
      changeSubscriptionofItem(line.key, merchandiseId, quantity);
      return;
    }
    changeCartItemBySellingPlan(rechargeSubsctibtionOptions[0].value);
  }

  const rechargeElements = getRechargeDataFromStorage();
  const rechargeSubsctibtionOptions = rechargeElements && rechargeElements[line.id + ''];
  const subscriptionMessage = line.variantMetafields?.subscriptionMessage || sellingPlanTextChoosen;
  const fauxComparePrice = line.variantMetafields && line.variantMetafields.fauxComparePrice && Number(line.variantMetafields.fauxComparePrice);
  const isBundle = line.merchandise;
  useEffect(() => {
    removeCartSkeleton()
  })
  const lineItem = useMemo(
    () => (
      <div key={line.key} id={`line-${line.id}`} className={`group-[.loading]:hidden p-5 border-b border-grey-D0 items-start flex`}>
        {isBundle ? (
          <a
            href={line.url}
            className="flex basis-[95px] max-w-[95px] min-w-[95px] lg:basis-[95px] lg:max-w-[95px] lg:min-w-[95px] h-[136px]"
          >
            <Image
              src={line.merchandise.product.image.src}
              classes="block object-contain max-w-full max-h-full w-auto h-auto"
              alt={line.merchandise.product.image.alt}
            />
          </a>
        ) : freeSample ? (
          <div
            href={line.url}
            className="flex basis-[95px] max-w-[95px] min-w-[95px] lg:basis-[95px] lg:max-w-[95px] lg:min-w-[95px] h-[136px]"
          >
            <Image
              src={line.featured_image.url}
              classes="block object-contain max-w-full max-h-full w-auto h-auto"
              alt={line.featured_image.alt}
            />
          </div>
        ) : (
          <a
            href={line.url}
            className="flex basis-[95px] max-w-[95px] min-w-[95px] lg:basis-[95px] lg:max-w-[95px] lg:min-w-[95px] h-[136px]"
          >
            <Image
              src={line.featured_image.url}
              classes="block object-contain max-w-full max-h-full w-auto h-auto"
              alt={line.featured_image.alt}
            />
          </a>
        )}

        <div className="flex-1 pl-5 flex flex-col justify-between">
          <div>
            <div className="flex justify-between mb-1">
              {isBundle ?
                <div className="body-xs text-grey-2A no-underline">
                  {isBundle.product.title}
                </div> : freeSample ? (
                  <div className="body-xs text-grey-2A no-underline">
                    {line.product_title}
                  </div>
                ) : (
                  <a
                    href={line.url}
                    className="body-xs text-grey-2A no-underline"
                  >
                    {line.product_title}
                  </a>
                )}
              {line.original_price !== line.final_price || isBundle && line.final_price !== line.cost.totalAmount.amount ?
                <div class="flex flex-col">
                  <div className="body-xs  text-grey-2A pl-2">
                    {extractAndFormat(formatMoney({ amount: line.final_price }, true))}
                  </div>
                  <div className="body-xs line-through text-grey-5C pl-2">
                    {isBundle ? extractAndFormat(formatMoney({ amount: line.cost.totalAmount.amount }, true)) : line.price ?
                      extractAndFormat(formatMoney({ amount: line.original_price }, true)) : window.TMW.Strings.cart.freeItem}
                  </div>
                </div> :
                <div className="body-xs text-grey-2A pl-2">
                  {isBundle ? 
                    <span className={`body-xs  text-grey-2A pl-2`}>{extractAndFormat(formatMoney({ amount: line.cost.totalAmount.amount }, true))}</span> : 
                      line.price ? 
                        <span className={`body-xs  text-grey-2A pl-2`}>{extractAndFormat(formatMoney({ amount: line.original_price }, true))}</span> : 
                        <span className={`body-xs  text-grey-2A pl-2`}>{window.TMW.Strings.cart.freeItem}</span>}
                  {fauxComparePrice > 0 && fauxComparePrice != line.original_price  && !line.selling_plan_allocation && <span className={`ml-1 line-through`}>{extractAndFormat(formatMoney({ amount: fauxComparePrice }, true))}</span>}
                  {line.selling_plan_allocation && line.selling_plan_allocation.compare_at_price && <span class="ml-1 line-through">{extractAndFormat(formatMoney({ amount: line.selling_plan_allocation.compare_at_price }, true))}</span>}
                </div>}
            </div>

            <div className="text-grey-5C body-xs mb-2.5">
              {line.variant_title}
            </div>
            <button class="hidden toggle-error" onClick={() => setErrorMessage('You have reached the limit for this item.')}></button>
            <div className='flex flex-wrap mb-5 items-center'>
              {rechargeSubsctibtionOptions && Object.keys(rechargeSubsctibtionOptions).length ?
                <div className={`text-grey-5C body-xs flex items-center justify-start mb-1 w-full`}>
                  <input
                    className="peer h-3.5 min-w-3.5 m-0 mt-[1px] cursor-pointer relative p-0 appearance-none rounded-none border-gray-B4 shadow-none checked:border-supergoop-blue checked:bg-supergoop-blue checked:text-white checked:hover:border-supergoop-blue checked:focus:border-supergoop-blue checked:focus:bg-supergoop-blue before:content-[''] before:block before:absolute before:w-1 before:h-2 before:border before:border-white before:border-b-[1px] before:border-r-[1px] before:border-t-0 before:border-l-0 before:rotate-45 before:top-1/2 before:-translate-y-1/2 before:-translate-x-1/2 before:left-1/2 before:mt-[-1px] self-start"
                    type="checkbox"
                    onChange={changeSellingPlan}
                    checked={line.selling_plan_allocation}
                    name={`freeShip-${line.id}`}
                    id={`free-ship-${line.id}-${index}`}
                  />
                  <label
                    htmlFor={`free-ship-${line.id}-${index}`}
                    className="pl-2.5 cursor-pointer mr-2.5"

                  >
                    {line.selling_plan_allocation ? sellingPlanText : subscriptionMessage}
                  </label>
                </div> : ''}
              {line.selling_plan_allocation && rechargeSubsctibtionOptions &&
                <div>
                  <label for={`${line.product_title}-${index}`} class="sr-only">{window.TMW.Strings.cart.subscription}</label>
                  <select id={`${line.product_title}-${index}`} className='px-2.5 py-1.5 pr-7 my-0 recharge-select' onChange={(e) => handleUpdateRechargeItem(e)} value={line.selling_plan_allocation.selling_plan.id}>
                    {rechargeSubsctibtionOptions && Object.keys(rechargeSubsctibtionOptions).map((key) => {
                      return <option value={+rechargeSubsctibtionOptions[key].value}>
                        {rechargeSubsctibtionOptions[key].text.replace('Deliver every', '')}
                      </option>
                    })}
                  </select>
                </div>}
              {line.selling_plan_allocation && rechargeSubsctibtionOptions && <span className='text-grey-5C body-xs mt-2 w-full'>{subscriptionMessage}</span>}
            </div>

          </div>
          {errorMessage && (
            <p className="text-error body-xs my-2">{errorMessage}</p>
          )}
          <div className="flex justify-between">
            {freeSample ? (
              <div className="w-1 h-1 lg:hidden block"></div>
            ) : (
              <div className="flex items-center relative mr-5">
                <button
                  onClick={() => handleAdjustQuantity(line.quantity - 1)}
                  aria-label={window.TMW.Strings.cart.decreaseQuantity}
                  className="text-white absolute left-0.5 scale-75"
                >
                  <IconMinus />
                </button>
                <div className="flex items-center justify-center body-xs text-grey-2A border-grey-B4 border w-[90px] h-8 text-center !appearance-none">
                  {line.quantity}
                </div>
                <button
                  onClick={() => handleAdjustQuantity(line.quantity + 1)}
                  aria-label={window.TMW.Strings.cart.increaseQuantity}
                  className="text-white absolute right-0.5 scale-75"
                >
                  <IconPlus />
                </button>
              </div>
            )}

            <button
              onClick={() => handleRemove()}
              className="body-xs text-grey-5C underline hover:no-underline"
            >
              {window.TMW.Strings.cart.remove}
            </button>
          </div>
        </div>
      </div>
    ),
    [line, errorMessage],
  );

  return lineItem;
};

export default withCartContext(CartItem);
